import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import { hasLobbyOrigin, rememberLobbyOrigin, returnToLobby } from '@/utils/lobbyReturn';

/**
 * Back-navigation bar when the user arrived from the Lobby.
 * Navigates to /tenant/{code}/lobby/{slug} (or the exact lobby URL passed via lobbyReturn).
 *
 * This bar is also what captures the lobby origin for the rest of the session — the
 * post-submission "Back to Lobby" CTA reads the same session state (see utils/lobbyReturn).
 */
export default function LobbyBackBar() {
  const [searchParams] = useSearchParams();
  const fromLobbyParam = searchParams.get('from') === 'lobby';

  useEffect(() => {
    if (fromLobbyParam) rememberLobbyOrigin(searchParams);
  }, [fromLobbyParam, searchParams]);

  if (!hasLobbyOrigin(searchParams)) return null;

  const handleBack = () => {
    returnToLobby(searchParams);
  };

  return (
    <button
      type="button"
      onClick={handleBack}
      aria-label="Back to Lobby"
      className="fixed top-3 left-3 z-50 flex items-center justify-center w-8 h-8 rounded-full bg-black/60 backdrop-blur-sm text-white hover:bg-black/80 transition-colors"
    >
      <ChevronLeft className="w-5 h-5 flex-shrink-0" strokeWidth={2.5} />
    </button>
  );
}
